import { render, staticRenderFns } from "./g-hls-video.vue?vue&type=template&id=3b84fe3f&scoped=true&"
import script from "./g-hls-video.vue?vue&type=script&lang=ts&"
export * from "./g-hls-video.vue?vue&type=script&lang=ts&"
import style0 from "./g-hls-video.vue?vue&type=style&index=0&id=3b84fe3f&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84fe3f",
  null
  
)

export default component.exports